import { render, staticRenderFns } from "./ProductUsageTables.vue?vue&type=template&id=353060f3&scoped=true&"
import script from "./ProductUsageTables.vue?vue&type=script&lang=js&"
export * from "./ProductUsageTables.vue?vue&type=script&lang=js&"
import style0 from "./ProductUsageTables.vue?vue&type=style&index=0&id=353060f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353060f3",
  null
  
)

export default component.exports